import Vue from 'vue';
import App from './App';
import router from './router';

import 'babel-polyfill'; // babel-polyfill 引入 ES6 轉 ES5

import ElementUI from 'element-ui'; // element-ui
import locale from 'element-ui/lib/locale/lang/en';
import 'element-ui/lib/theme-chalk/index.css';

import fastclick from 'fastclick'; // fastclick -1 引入 / 解決300毫秒延遲
import VueLazyLoad from 'vue-lazyload'; // 懒加载

import 'assets/scss/index.scss';

fastclick.attach(document.body);

Vue.use(ElementUI, { locale });

Vue.use(VueLazyLoad, { // 懒加载
  preLoad: 1, // 加载可见页面面积 小于1 移动一点点下面就会开始加载
  error: require('assets/img/error.png'), // 错误显示
  loading: require('assets/img/loading.gif'), // 成功显示
  attempt: 1 // 加载次数
});

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js